import { createExpandedSections } from "@shared/components/menus/expanded-sections"

// Beside NonInstructionalMenu rather than in it: a module exporting a component may export nothing
// else, or Fast Refresh gives up (enforced by react-refresh/only-export-components).

/** Which sections start expanded. Union of the editable + readonly options. */
export const expandedSections = createExpandedSections(["copy-paste", "remove", "copy-readonly"])
